module.exports = require('./FlaggedLabelView');
